module.exports = require('./FlaggedLabelView');
